<div class="side-panel">
  <h3-side-panel-tabs></h3-side-panel-tabs>

  @switch (selectedTabName$ | async) {
    @case (annotationTabName) {
      <h3-annotation-panel></h3-annotation-panel>
    }
    @case (settingsTabName) {
      <h3-settings-panel></h3-settings-panel>
    }
  }
</div>
